import { i18n } from "../../../language";
import store from "../../../store/";

let isDarkMode = () => store.state.user.darkMode;

const labelOption = {
    show: true,
    position: "inside",
    verticalAlign: "middle",
    rotate: 0,
    formatter: "{c}",
    fontSize: 11,
    rich: {
        name: {
            textBorderColor: "#fff",
        },
    },
};

function subFormatter(value) {
    let date = value[0].axisValue;
    let items = value.map((x) => x.marker + " " + x.seriesName + ": " + (x.data || 0)).join("<br>");
    let totalBarValue = _.sum(value.map((x) => x.data));
    return `${date} <br> ${i18n.t("report.totalBar")}: ${totalBarValue} <br> ${items}`;
}

const colors = ["#eed2ee", "#ee7942", "#ee6363", "#eedc82", "#9bcd9b", "#b2dfee", "#a2b5cd", "#1c86ee"];
const symbols = ["circle", "rect", "roundRect", "triangle", "diamond", "pin", "arrow"];

export default function getData(data, series, max, daily = false) {
    return {
        legend: {
            show: true,
            data: Object.keys(series),
            textStyle: {
                color: isDarkMode() ? "white" : "black",
            },
        },
        responsive: true,
        maintainAspectRatio: false,
        grid: {
            left: 100,
        },
        color: ["#003366", "#006699", "#4cabce", "#e5323e"],
        toolbox: {
            feature: {
                saveAsImage: {
                    pixelRatio: 2,
                    title: "Save",
                },
            },
        },
        tooltip: {
            trigger: "axis",
            axisPointer: {
                type: "shadow",
            },
            formatter: !daily ? subFormatter : null,
        },
        xAxis: {
            type: "category",
            axisLabel: {
                rotate: 45,
                color: isDarkMode() ? "white" : "black",
            },
            data,
        },
        yAxis: {
            type: "value",
            scale: true,
            splitNumber: 5,
            max,
            logBase: 5,
            min: 0,
            axisLabel: {
                color: isDarkMode() ? "white" : "black",
            },
        },

        series: !daily
            ? Object.keys(series).map((name, i) => {
                  const color = colors[i % colors.length];

                  return {
                      name,
                      type: "bar",
                      stack: "a",
                      symbol: symbols[i % symbols.length],
                      symbolSize: 5,
                      barGap: 0,
                      barWidth: 30,
                      label: labelOption,
                      data: series[name],
                      itemStyle: {
                          color: color,
                      },
                  };
              })
            : {
                  name: "",
                  type: "bar",
                  stack: "a",
                  symbolSize: 5,
                  barGap: 0,
                  barWidth: 30,
                  label: labelOption,
                  data: Object.keys(series).map((x) => series[x]),
              },
    };
}
